import { render, staticRenderFns } from "./AccordionList.vue?vue&type=template&id=65cbdefb&scoped=true&"
import script from "./AccordionList.vue?vue&type=script&lang=js&"
export * from "./AccordionList.vue?vue&type=script&lang=js&"
import style0 from "./AccordionList.vue?vue&type=style&index=0&id=65cbdefb&lang=sass&scoped=true&"
import style1 from "./AccordionList.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cbdefb",
  null
  
)

export default component.exports